export function fmtIDR(n) {
  const v = Number(n || 0);
  return "Rp " + v.toLocaleString("id-ID", { maximumFractionDigits: 0 });
}

export function fmtNum(n) {
  const v = Number(n || 0);
  return v.toLocaleString("id-ID", { maximumFractionDigits: 2 });
}

export function fmtDate(s) {
  if (!s) return "-";
  try {
    return new Date(s).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "short" });
  } catch {
    return s;
  }
}

export function todayStr(offsetDays = 0) {
  const d = new Date();
  d.setDate(d.getDate() + offsetDays);
  return d.toISOString().slice(0, 10);
}

export function waUrl(phone) {
  if (!phone) return "";
  let d = String(phone).replace(/\D/g, "");
  if (d.startsWith("0")) d = "62" + d.slice(1);
  return d ? `https://wa.me/${d}` : "";
}

export function PhoneLink({ phone }) {
  const url = waUrl(phone);
  if (!url || phone === "-") return <span>{phone || "-"}</span>;
  return (
    <a href={url} target="_blank" rel="noreferrer" className="text-emerald-600 hover:text-emerald-700 hover:underline font-medium">
      {phone}
    </a>
  );
}
